export default __webpack_public_path__ + "static/media/CN.f3921507.svg";